import React from 'react';
import { MdZoomOut } from 'react-icons/md';

function ChartZoomOutPill({ onClick, ariaLabel = 'Zoom out' }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      className="absolute bottom-3 left-3 z-10 flex justify-center items-center gap-2 rounded-full bg-white/95 px-3 py-2 text-sm font-medium text-gray-800 shadow-md ring-1 ring-black/5 transition hover:bg-white hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 md:text-lg md:w-24"
    >
      <MdZoomOut className="text-lg md:text-2xl" aria-hidden />
    </button>
  );
}

export default ChartZoomOutPill;